var $710e3e95d2a199c9$exports = {};
$710e3e95d2a199c9$exports = {
    "removeButtonLabel": `Ta bort`,
    "removeDescription": `Tryck p\xe5 Radera f\xf6r att ta bort taggen.`
};


export {$710e3e95d2a199c9$exports as default};
//# sourceMappingURL=sv-SE.mjs.map
